<template>
  <el-dialog title="上传图片" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-upload class="upload-demo" limit="10" drag action="" multiple :show-file-list="false" :before-upload="beforeUpload">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将目录或者多个视频/音频拖拽到次，或单击<em>点击上传</em><br />最多支持10个视频/音频同时上传</div>
      </el-upload>
      <el-table :data="uploadFilesList" style="width: 100%">
        <el-table-column prop="name" :show-overflow-tooltip="true" label="名称">
          <template slot-scope="{row}">
            <el-input v-model="row.name" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="是否成功" width="300">
          <template slot-scope="{row}">
            <!-- <template v-if="row.status==='success'">上传成功！</template> -->
            <template v-if="row.status==='error'">上传失败!</template>
            <el-progress v-else :percentage="row.progress" />
          </template>
        </el-table-column>
        <el-table-column width="120" prop="size" label="大小" />
        <el-table-column prop="name" width="120" :show-overflow-tooltip="true" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleDelItem(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import mainImageApi from '@/api/meeting/mainImage'
import { getToken } from '@/utils/auth'
import ImageUpload from "@/components/ImageUpload";
import axios from 'axios'


export default {
  components: { ImageUpload },
  data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
      headers: {
        Authorization: 'DU ' + getToken()
      },
      formVisible: false,
      uploadFilesList: [],
      isRepSub: false
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.uploadFilesList = []
    },
    beforeUpload(file) {
      const fileList = {}
      for (const key in file) {
        fileList[key] = file[key]
      }
      // status:uploading、success、error 文件上传状态
      // progress 文件上传进度
      this.uploadFilesList.push({ ...fileList, progress: 0, status: 'uploading' })
      this.httpRequest(file, parms => {
        this.showProgress(fileList, parms)
      })
      // 阻止 el-upload的默认上传
      return false
    },
    showProgress(file, parms) {
      const { progress, status, url } = parms
      const arr = [...this.uploadFilesList].map(items => {
        if (items.uid === file.uid) {
          items.progress = progress
          items.status = status
          items.url = url
        }
        return items
      })
      this.uploadFilesList = [...arr]
    },
    async httpRequest(file, callback) {
      var formData = new FormData();
      // file是上传的文件
      formData.append("file", file);
      let progress = 0
      axios({
        headers: { 'Content-Type': 'application/json;charset=UTF-8', Authorization: 'DU ' + getToken() },
        method: 'post',
        url: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
        data: formData,
        onUploadProgress: progressEvent => { // 获取文件上传进度 axios自带的
          progress = (progressEvent.loaded / progressEvent.total * 100) | 0
          callback({ progress, status: 'uploading' })
        }
      }).then((res) => { // 成功状态
        // console.log(res.data.data)
        callback({ progress, status: 'success', url: res.data.data })
      }).catch(() => { // 失败状态
        callback({ progress, status: 'error' })
      })
    },
    handleCreate(row) {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let arr = []
      this.uploadFilesList.forEach(item => {
        let { name, url, progress } = item
        if (progress === 100 && url) {
          arr.push({ name, url })
        }
      })
      if (!arr.length) return this.$message.error('请上传图片！')
      if (this.isRepSub) return
      this.isRepSub = true
      mainImageApi.createBatch(arr).then((data) => {
        this.postCallback(data)
      }).catch(res => {
        this.isRepSub = false
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleDelItem(scope) {
      this.uploadFilesList.splice(scope.$index, 1)

    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .upload-demo {
  text-align: center;
  margin-bottom: 10px;
}
</style>
